import getFontPairs from './font-pairs';
import getCustomFontPairs from './custom-font-pairs';

const getFontPair = (state, fontPairId) => {
  const fontPairs = getFontPairs(state);
  const customFontPairs = getCustomFontPairs(state);

  return [...fontPairs, ...customFontPairs].find((fontPair) => fontPair.id === fontPairId) || null;
};

export default getFontPair;
